const AccountModule = {
  components: {
    Adsense,
    'user-info': UserInfo,
    'user-email': UserEmail,
    'user-delete': UserDelete,
    'user-mailing': UserMailing,
    'user-password': UserPassword,
    'user-push': UserPush,
  },
  computed: {
    user() {
      return domestiko.user;
    },
  },
  template: `
    <div class="account uk-margin-large-bottom">
      <div class="uk-block" v-if="!user.profile">
        <h3>Datos de la cuenta</h3>
        <user-info></user-info>
      </div>
      <div class="uk-section">
        <h3>Correo electrónicos</h3>
        <user-mailing></user-mailing>
      </div>
      <div class="uk-section">
        <h3>Notificaciones push</h3>
        <user-push></user-push>
      </div>
      <div class="uk-section">
        <h3>Cambiar contraseña</h3>
        <user-password></user-password>
      </div>
      <div class="uk-section">
        <h3>Cambiar correo electrónico</h3>
        <p>
          Si quieres modificar tu dirección de e-mail indica en el siguiente cuadro la nueva dirección. Al guardar los
          cambios te enviaremos un correo de confirmación a la nueva dirección de e-mail para validarla.
        </p>
        <user-email></user-email>
      </div>
      <hr>
      <div class="uk-section">
        <h3>Darse de baja</h3>
        <p>
          Si te das de baja se eliminaran todos tus datos y tus clientes y/o contratadores ya no podrán acceder a tu
          perfil.
        </p>
        <p>
          Tampoco podrás recibir correos desde las ofertas de trabajo o presupuestos en los que hayas presentado tu
          candidatura.
        </p>
        <user-delete></user-delete>
      </div>
    </div>
  `,
};
